import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import { months } from 'wfui-digital-core/es/lib';
import logger from '../../../../lib/logger/logger';
import getTimezone from './get-timezone';

var getLastLogonMessageParts = function getLastLogonMessageParts(_ref) {
  var language = _ref.language,
      getString = _ref.getString,
      lastLogonTimeStamp = _ref.lastLogonTimeStamp,
      timeZone = _ref.timeZone;
  var lastLogon;

  try {
    lastLogon = new Date(Date.parse(lastLogonTimeStamp)); // Force a particular timezone, if specified. Mostly exists for testing

    if (timeZone) {
      lastLogon = new Date(lastLogon.toLocaleString('en-US', {
        timeZone: timeZone
      }));
    }

    if (isNaN(lastLogon.getTime())) {
      // Some Date/Date.parse implemenations will not throw on invalid
      // timestamps
      throw new Error("Invalid lastLogonTimeStamp: ".concat(lastLogonTimeStamp));
    }
  } catch (e) {
    logger.warn('Failed to parse lastLogonTimestamp', e);
    return undefined;
  }

  var logonMonth = months(getString)[lastLogon.getMonth()].name;
  return {
    logonMonth: language === 'sp' ? logonMonth.toLowerCase() : logonMonth,
    logonDate: lastLogon.getDate(),
    logonYear: lastLogon.getFullYear(),
    logonTime: lastLogon.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }).toLowerCase(),
    logonTimezone: getTimezone({
      date: lastLogon,
      timeZone: timeZone,
      language: language,
      timeZoneName: 'short'
    })
  };
};

export default getLastLogonMessageParts;